module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "category-list"
  }, _vm._l((_vm.categories[_vm.selectedProductType]), function(category) {
    return _c('div', {
      key: category.id,
      staticClass: "category-item",
      style: (_vm.isSingle ? _vm.singleChoice : '')
    }, [(_vm.isMultiple) ? _c('label', [_c('input', {
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": _vm.isChecked(category)
      },
      on: {
        "change": function($event) {
          _vm.filterMultiple($event, category)
        }
      }
    }), _vm._v(" "), _c('span', [_vm._v("\n        " + _vm._s(category.name) + "\n      ")])]) : _vm._e(), _vm._v(" "), (_vm.isSingle) ? _c('button', {
      class: _vm.isSelected(category.id) ? 'selected' : '',
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.filterSingle(category)
        }
      }
    }, [_vm._v("\n      " + _vm._s(category.name) + "\n    ")]) : _vm._e()])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1592ef42","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-webpack-plugin/loader.js?id=1udq9m5yalv!./~/string-replace-webpack-plugin/loader.js?id=5v3roo83miv!./src/components/ecommerce/filter/Categories.vue
// module id = 711
// module chunks = 0